var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHeartOutline = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 77c-.975.006-1.911-.377-2.603-1.063L12.907 47.41c-7.438-7.515-7.438-19.618 0-27.133 7.499-7.478 19.634-7.478 27.133 0l3.96 3.96 3.96-3.96c7.499-7.478 19.634-7.478 27.133 0 7.438 7.515 7.438 19.618 0 27.133l-28.49 28.527c-.692.686-1.628 1.069-2.603 1.063zM26.473 22c-3.135-.014-6.145 1.227-8.36 3.447-4.61 4.634-4.61 12.122 0 16.756L44 68.127l25.887-25.924c4.61-4.634 4.61-12.122 0-16.756-4.692-4.433-12.028-4.433-16.72 0l-6.564 6.6c-1.426 1.437-3.747 1.447-5.185.02l-.021-.02-6.564-6.6c-2.214-2.22-5.224-3.461-8.36-3.447z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeartOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heartOutline.5f48a980.svg";
export { ForwardRef as ReactComponent };